"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var Players_module_css_1 = __importDefault(require("./Players.module.css"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var react_i18next_1 = require("react-i18next");
var q_play_components_2 = require("@nordicscreen/q-play-components");
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var q_play_core_1 = require("@nordicscreen/q-play-core");
var AddEventModal = function (_a) {
    var isShown = _a.isShown, toggle = _a.toggle, _b = _a.players, players = _b === void 0 ? [] : _b, setPlayerDetailsModalShown = _a.setPlayerDetailsModalShown, bulkAction = _a.bulkAction;
    var defaultSavingState = { saving: false, saved: false, text: "" };
    var _c = (0, react_1.useState)(defaultSavingState), savingState = _c[0], setSavingState = _c[1];
    var _d = (0, react_1.useState)([]), events = _d[0], setEvents = _d[1];
    var _e = (0, react_1.useState)([]), selectedEvents = _e[0], setSelectedEvents = _e[1];
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _f = (0, react_1.useState)([]), attachedEvents = _f[0], setAttachedEvents = _f[1];
    var logger = q_play_core_1.logManager.getLogger();
    var getEvents = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ApiManager_1.default.getEvents()];
                case 1:
                    response = _a.sent();
                    setEvents(response);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    logger.error("Error fetching events:", error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getAttachedEvents = function () { return __awaiter(void 0, void 0, void 0, function () {
        var playerIds, response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    playerIds = players.map(function (player) { return player.id; });
                    return [4 /*yield*/, ApiManager_1.default.getPlayerEvents(playerIds)];
                case 1:
                    response = _a.sent();
                    setAttachedEvents(response);
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    logger.error("Error fetching player events:", error_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        if (isShown) {
            getEvents();
            getAttachedEvents();
        }
    }, [isShown, players]);
    var addPlayerEvent = function () { return __awaiter(void 0, void 0, void 0, function () {
        var playerIds, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(selectedEvents.length > 0 && players.length > 0)) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    playerIds = players.map(function (player) { return player.id; });
                    return [4 /*yield*/, ApiManager_1.default.addEventsToPlayers(playerIds, selectedEvents)];
                case 2:
                    _a.sent();
                    setSavingState(__assign(__assign({}, defaultSavingState), { saved: true, text: "Events added successfully" }));
                    getAttachedEvents();
                    toggle();
                    if (!bulkAction && players.length === 1) {
                        setPlayerDetailsModalShown(true);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_3 = _a.sent();
                    logger.error("Error adding player events:", error_3);
                    setSavingState(__assign(__assign({}, defaultSavingState), { saved: false, text: "Error adding events" }));
                    toggle();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        if (!isShown) {
            setSelectedEvents([]);
            setSavingState(defaultSavingState);
        }
    }, [isShown]);
    var filteredEvents = (0, react_1.useMemo)(function () {
        return events.filter(function (event) {
            return !players.every(function (player) {
                return attachedEvents.some(function (attachedEvent) {
                    return attachedEvent.event_id === event.id && attachedEvent.player_id === player.id;
                });
            });
        });
    }, [events, players, attachedEvents]);
    var handleEventSelection = function (eventId) {
        setSelectedEvents(function (prevSelectedEvents) {
            return prevSelectedEvents.includes(eventId)
                ? prevSelectedEvents.filter(function (id) { return id !== eventId; })
                : __spreadArray(__spreadArray([], prevSelectedEvents, true), [eventId], false);
        });
    };
    var handleBackNavigation = function () {
        toggle();
        if (!bulkAction && players.length === 1) {
            setPlayerDetailsModalShown(true);
        }
    };
    return (react_1.default.createElement(q_play_components_2.Modal, { isShown: isShown, onClose: toggle, dialogClassName: Players_module_css_1.default["event-modal-dialog"], centered: true, dataCy: "addEventModal", body: react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: Players_module_css_1.default["add-event-modal-header"] },
                react_1.default.createElement(q_play_components_1.Button, { className: "p-0", style: { minWidth: "50px" }, variant: "empty", onClick: handleBackNavigation },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faAngleLeft, color: "var(--primary-color)", size: "2x" })),
                react_1.default.createElement("span", null, t("Add event"))),
            react_1.default.createElement("div", { className: "".concat(Players_module_css_1.default["filtered-events-container"], " mt-4") }, filteredEvents.map(function (event) { return (react_1.default.createElement("div", { key: event.id },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faAngleRight, color: "var(--info-color)", size: "1x", className: "mr-2", style: { marginRight: "5px" } }),
                react_1.default.createElement("span", { style: {
                        cursor: "pointer",
                        borderRadius: selectedEvents.includes(event.id) ? "3px" : "none",
                        backgroundColor: selectedEvents.includes(event.id) ? "var(--secondary-color-tinted)" : "transparent",
                        outline: selectedEvents.includes(event.id) ? "2px var(--primary-color) solid" : "none",
                        transition: "opacity 0.3s",
                        padding: "6px"
                    }, onMouseOver: function (e) { return e.currentTarget.style.opacity = "0.5"; }, onMouseOut: function (e) { return e.currentTarget.style.opacity = "1"; }, onClick: function () { return handleEventSelection(event.id); }, "data-cy": "eventTitle" }, event.title))); })),
            react_1.default.createElement("div", { className: "d-flex justify-content-end mt-4" },
                savingState.saved &&
                    react_1.default.createElement("span", { style: { fontFamily: "Geomanist", margin: "auto 1rem" } }, t(savingState.text)),
                react_1.default.createElement(q_play_components_1.Button, { text: t("Add event"), size: "small", dataCy: "attachEventButton", onClick: addPlayerEvent }))) }));
};
exports.default = AddEventModal;
